/* Wheelhouse build-choice presentation only. Existing DPO selects remain the source of truth. */
(() => {
  if (window.whBuildChoicesLoaded) return;
  window.whBuildChoicesLoaded = true;
  const root = document.querySelector('.productView-product');
  if (!root) return;
  const records = new WeakMap();
  const styles = document.createElement('style');
  styles.id = 'wh-build-choice-styles';
  styles.textContent = `
  .wh-build-select-source{position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;clip-path:inset(50%)!important;white-space:nowrap!important;opacity:0!important;pointer-events:none!important}
  .wh-build-choices{display:flex;flex-wrap:wrap;gap:8px;margin:0 0 18px;min-width:0}
  .wh-build-choice{appearance:none;background:#fff;color:#161D26;border:1px solid #c8c8c8;border-radius:0;padding:11px 13px;min-height:44px;max-width:100%;text-align:left;font:inherit;font-size:14px;font-weight:500;line-height:1.4;white-space:normal;overflow-wrap:anywhere;cursor:pointer;transition:border-color 150ms ease,background 150ms ease}
  .wh-build-choice[aria-checked=true]{border-color:#161D26;box-shadow:inset 0 -3px 0 #F1B53B;background:#faf7ef}
  .wh-build-choice:focus-visible{outline:2px solid #F1B53B;outline-offset:3px}
  .wh-build-choice:disabled{opacity:.45;cursor:not-allowed;text-decoration:line-through}
  .wh-build-clear{appearance:none;background:transparent;border:0;padding:8px 0;min-height:44px;color:#161D26;text-decoration:underline;font:inherit;font-size:12px;cursor:pointer}.wh-build-clear:disabled{opacity:.4;cursor:default}.wh-build-clear:focus-visible{outline:2px solid #F1B53B;outline-offset:2px}
  .wh-build-choices-status{width:100%;font-size:13px;line-height:1.5;color:#444;margin:0}
  @media(max-width:600px){.wh-build-choice{width:100%;padding:11px 12px}.wh-build-choices{gap:7px}}
  @media(prefers-reduced-motion:reduce){.wh-build-choice{transition:none}}
  `;
  document.head.append(styles);
  const sync = (select, rec) => {
    const available = rec.buttons.filter(b => !b.disabled && !b.hidden);
    const chosen = available.find(b => b.dataset.value === select.value);
    for (const button of rec.buttons) {
      button.setAttribute('aria-checked', String(button.dataset.value === select.value && select.value !== ''));
      button.tabIndex = button === (chosen || available[0]) ? 0 : -1;
    }
    if (rec.clear) rec.clear.disabled=select.disabled || select.value==='';
    const value = select.selectedOptions[0]?.textContent.trim() || '';
    const text = select.value ? 'Selected: ' + value : 'Select one option to complete this part of your build.';
    if (rec.status.textContent !== text) rec.status.textContent = text;
    rec.group.setAttribute('aria-disabled', String(select.disabled));
  };
  const choose = (select, rec, button) => {
    if (select.disabled || button.disabled) return;
    select.value = button.dataset.value;
    // DPO's original change handler owns all pricing, dependencies and cart behavior.
    select.dispatchEvent(new Event('change', {bubbles:true}));
    sync(select, rec);
  };
  const enhance = (select) => {
    const field = select.closest('.field') || select.parentElement.parentElement;
    const label = field.querySelector('label') || select.parentElement.previousElementSibling;
    const title = label?.textContent.trim() || select.getAttribute('title') || '';
    if (!/group\s*sets?|wheel\s*sets?/i.test(title)) return;
    if (select.multiple) return;
    const fingerprint = JSON.stringify([...select.options].map(o => [o.value, o.textContent, o.disabled, o.hidden, o.style.display]));
    let rec = records.get(select);
    if (!rec) {
      const group = document.createElement('div');
      group.className = 'wh-build-choices';
      group.setAttribute('role','radiogroup');
      group.setAttribute('aria-label', title);
      group.setAttribute('aria-required', String(/required/i.test(select.getAttribute('validation') || '')));
      select.after(group);
      rec = {group, buttons:[], status:null, fingerprint:null};
      records.set(select, rec);
      select.addEventListener('change', () => sync(select,rec));
      if (window.jQuery) window.jQuery(select).on('change.whBuildChoices', () => sync(select,rec));
      group.addEventListener('keydown', e => {
        const button = e.target.closest('.wh-build-choice');
        if (!button || !['ArrowRight','ArrowDown','ArrowLeft','ArrowUp','Home','End'].includes(e.key)) return;
        const buttons = rec.buttons.filter(b => !b.disabled && !b.hidden);
        if (!buttons.length) return;
        let index = buttons.indexOf(button);
        if (e.key === 'Home') index = 0;
        else if (e.key === 'End') index = buttons.length - 1;
        else index = (index + (['ArrowRight','ArrowDown'].includes(e.key) ? 1 : -1) + buttons.length) % buttons.length;
        e.preventDefault();buttons[index].focus();choose(select,rec,buttons[index]);
      });
    }
    if (rec.fingerprint !== fingerprint) {
      rec.group.replaceChildren();rec.buttons=[];
      for (const option of select.options) {
        if (!option.value) continue;
        const button = document.createElement('button');
        button.type='button';button.className='wh-build-choice';button.setAttribute('role','radio');
        button.dataset.value=option.value;button.textContent=option.textContent.trim();button.disabled=option.disabled || select.disabled;button.hidden=option.hidden || option.style.display==='none';
        button.addEventListener('click', () => choose(select,rec,button));
        rec.group.append(button);rec.buttons.push(button);
      }
      rec.clear=document.createElement('button');rec.clear.type='button';rec.clear.className='wh-build-clear';rec.clear.textContent='Clear selection';rec.clear.setAttribute('aria-label','Clear '+title);rec.clear.addEventListener('click',()=>{select.value='';select.dispatchEvent(new Event('change',{bubbles:true}));sync(select,rec);});rec.group.append(rec.clear);
      rec.status=document.createElement('p');rec.status.className='wh-build-choices-status';rec.status.setAttribute('aria-live','polite');rec.group.append(rec.status);
      rec.fingerprint=fingerprint;
    }
    for (const button of rec.buttons) { const option=[...select.options].find(o=>o.value===button.dataset.value);button.disabled=select.disabled || !!option?.disabled;button.hidden=!!option?.hidden || option?.style.display==='none'; }
    sync(select,rec);
    // Hide only after the complete mirrored control exists. Validation and submission still use the original select.
    select.classList.add('wh-build-select-source');select.tabIndex=-1;select.setAttribute('aria-hidden','true');
  };
  let queued=false;
  const refresh = () => {
    queued=false;
    root.querySelectorAll('.dpo-container select.product-custom-option').forEach(enhance);
  };
  const queue = () => { if (!queued) { queued=true;queueMicrotask(refresh); } };
  const observer=new MutationObserver(mutations=>{if(mutations.some(m=>m.type==='childList' || ['SELECT','OPTION'].includes(m.target.tagName)))queue();});
  observer.observe(root,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','hidden','style']});
  refresh();
  window.whBuildChoicesRefresh=refresh;
})();
